export const MAX_CHAT_MESSAGE_LENGTH = 1000;
export class chatSources {
  static control = 'control';
  static recommendation = 'recommendation';
  static cmRecommendation = 'cm-recommendation';
}
